/// <reference types="jquery" />
/// <reference types="kendo-ui" />

class HicomFormEditor implements IHicomFormEditor {

    editor: kendo.ui.Editor;
    controlId: string;

    constructor(id) {
        this.controlId = id;
    }

    LoadEditor() {
        if (!this.editor) {
            this.editor = $("#" + this.controlId).data("kendoEditor");
        }       
    }

    /** HTML editor - file is selected for import - report any errors - handle incorrect file errors by reporting invalid file extension
     * @param e
     */
    EditorImportOnSelect(e) {
        let file = e.files[0];
        let errors = file.validationErrors;
        let localization = e.sender.options.localization;

        if (errors) {
            let $content = $('<ul></ul>');
            for (var i = 0; i < errors.length; i++) {
                switch (errors[i]) {
                    case 'invalidFileExtension':
                        $content.append(`<li><span>${localization[errors[i]]} - allowed extensions are: ${e.sender.options.validation.allowedExtensions.join(', ')}</span></li>`);
                        break;
                    case 'invalidMaxFileSize':
                        var maxFileSize = e.sender.options.validation.maxFileSize;//this will be in bytes
                        var sizeType = "B";
                        if (maxFileSize >= 1024) {
                            sizeType = "KB";
                            maxFileSize = maxFileSize / 1024;//now in kb
                        }
                        if (maxFileSize >= 1024) {
                            sizeType = "MB";
                            maxFileSize = maxFileSize / 1024;//now in mb
                        }
                        $content.append(`<li><span>${localization[errors[i]]} - Max file size: ${maxFileSize}${sizeType}</span></li>`);
                        break;
                    default:
                        $content.append(`<li><span>${localization[errors[i]]}</span></li>`);
                        break;
                }
            }
            $("<div></div>").kendoDialog({
                width: "450px",
                title: "HTML Editor - Error importing file",
                closable: true,
                modal: true,
                content: $content.html(),
                actions: [{ text: "OK" }]
            }).data("kendoDialog").open().center();
        }
    }

    EditorImportOnError(e) {
        alert("The Document Processing Library fails to convert the input file stream to html");
    }
    //state
    setDisabled() {
        this.LoadEditor();
        var element = $(this.editor.body);
        element.attr('contenteditable', 'false');
        element.css('opacity', 0.5);
        this.editor.toolbar.element.css('opacity', 0.5);
        $(this.editor.toolbar.element).addClass('k-state-disabled');
    }
    unSetDisabled() {
        this.LoadEditor();
        var element = $(this.editor.body);
        element.attr('contenteditable', 'true');
        element.css('opacity', 1.0);
        this.editor.toolbar.element.css('opacity', 1.0);
        $(this.editor.toolbar.element).removeClass('k-state-disabled');
    }
    setReadOnly() {
        this.LoadEditor();
        var element = $(this.editor.body);
        element.attr('contenteditable', 'false');
    }
    unSetReadOnly() {
        this.LoadEditor();
        var element = $(this.editor.body);
        element.attr('contenteditable', 'true');
    }

    // Word count indicator
    CheckWordCount() {
        var $span = $('#wordcount-' + this.controlId);
        var $spanWordCount = $span.find('.word-count');
        var $control = $('#' + this.controlId);
        var $editor = $(`#${this.controlId}`).data('kendoEditor');
        var maxWords = $span.data('max-words');
        if ($control.length && $editor) {
            var $body = $control.prev('iframe').contents().find('body');
            var html = $.trim($body[0].innerHTML);

            // @ts-ignore
            let words = HicomTextUtils.GetHTMLWordCount(html);
            if (words > maxWords) {
                $span.addClass('input-Validation-textarea');
            }
            else {
                $span.removeClass('input-Validation-textarea');
            }
            $spanWordCount.text(String(words));
        }
    }

    /**
     * Sets the fore colour, this is the colour of the selected text, and the colour the text will continue to type in.
     * @param colourPickerClass - The class name the user has selected in the colour picker.
     */
    setForeColour(colourPickerClass: string) {
        this.LoadEditor();
        if (colourPickerClass && this.editor) {

            // Call getCSSPropertiesByClassName from hicomExtensions.ts
            //@ts-ignore
            const cssProps = getCSSPropertiesByClassName(colourPickerClass, ['background']);

            //Default to black if no css props found
            let colorValue = 'rgb(0, 0, 0)';
            if (cssProps && cssProps['background']) {
                colorValue = cssProps['background'];
            }
            this.editor.exec('foreColor', { value: colorValue });
        }
    }

    /**
     * Sanitizes the HTML content of the editor.
     */
    SanitizeHtml() {
        this.LoadEditor();
        this.editor.value(DOMPurify.sanitize(this.editor.value(), { ADD_ATTR: ['target', 'title'] }));
    }

    onHicomEditorChange(e) {
        this.CheckWordCount();             

        //There is a strange bug with Kendo and DomPurify where if a link thats being added has not been adjusted, Kendo will fail its update in a very vauge manner,
        //the way we fix it is seperating out the sanitize method so it occurs when the insert link button is clicked, rather than here and that allows it too work.
        const alreadyDone: boolean = Boolean($(".k-dialog-insert").attr("SanitizedAlready"));
        if (!alreadyDone) {
            e.sender.value(DOMPurify.sanitize(e.sender.value(), { ADD_ATTR: ['target', 'title'] }));
        }
    }
    onHicomEditorKeyUp(e) {
        this.CheckWordCount();        
    }

    onControlLoad(e) {
        this.CheckWordCount();
    }
    //static methods
    static getInstance(element: HTMLInputElement): HicomFormEditor {
        return window["hicomFormEditor" + element.getAttribute("name")];
    }

    /**
     * Toggles the fullscreen mode for the editor.
     * @param e - The triggered event.
     */
    static toggleFullscreen(e: Event, editorId: string) {
        const editorWrapper = $("#" + editorId).data("kendoEditor")?.wrapper;

        if (!editorWrapper) { return; }

        if (editorWrapper.hasClass('h-editor-fullscreen')) {
            editorWrapper.removeClass('h-editor-fullscreen btn-danger');
            $(e.currentTarget).removeClass('btn-danger')
        } else {
            editorWrapper.addClass('h-editor-fullscreen btn-danger');
            $(e.currentTarget).addClass('btn-danger')
        }
    }

    /**
     * Paste cleanup custom function for the editor. It uses the DOMPurify library to sanitize the pasted HTML.
     * @param html - The HTML to be sanitized.
     * @returns - The sanitized HTML.
     */
    static PasteCleanupCustom(html) {
        return DOMPurify.sanitize(html, { ADD_ATTR: ['target', 'title'] });
    }

}